import {Component, Inject, OnInit} from "@angular/core";
import {NavigationExtras, Router} from "@angular/router";
import {AuthService} from "../../services";
import {environment} from "../../../../environments/environment";
import {UtilService} from "../../services/util/util.service";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: "app-admin-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  animations: [] // [routerTransition()]
})
export class AdminPortalLoginComponent implements OnInit {
  loginInvalid: boolean = false;

  password: string = "";
  username: string = "";
  ver: String;
  system: string = "";
  appTitle: string = "Admin Portal";

  constructor(public router: Router, private authService: AuthService,
              private utilService: UtilService,
              @Inject(DOCUMENT) private document: Document,) {

    this.ver = this.utilService.getEnvironmentString(environment)
    this.system = this.extractSystemName();
  }

  extractSystemName(document: Document = this.document) {
    const {hostname} = document.location;
    const systemName = hostname.replace(environment.domain, '').replace('.', '')
    if (!systemName.includes(hostname)) return systemName;
    return '';
  }

  ngOnInit() {
  }

  onLogin(formValues) {
    this.loginInvalid = false; // reset
    let loginPayload: LoginPayload = {
      Username: formValues.username,
      Password: formValues.password,
      SystemName: formValues.system
    };

    this.authService
      .authenticateAdmin(loginPayload)
      .then(() => {
        this.router.navigate(["/admin-portal/physicians"]);
      })
      .catch((error: any) => {
        console.log(error);
        this.loginInvalid = true;
      });
  }

  forgotPassword() {
    let navigationExtras: NavigationExtras = {
      queryParams: {redirect: "/admin-portal/login"}
    };
    this.router.navigate(["/password/forgot"], navigationExtras);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/login/admin-portal-login.component.ts